import React, { useState } from 'react';
import styles from '../modules/chat/ChatInputBar.module.css';
import { FaArrowUp, FaBullhorn } from 'react-icons/fa';
import FeedbackModal from '../modules/feedback/FeedbackModal';

const ChatInputBar = ({ inputMessage, setInputMessage, handleSendMessage }) => {
  const [isFeedbackOpen, setIsFeedbackOpen] = useState(false);

  const toggleFeedbackModal = () => {
    setIsFeedbackOpen((prev) => !prev);
  };

  return (
    <div className={styles.inputContainer}>
      <div className={styles.inputShell}>
        <textarea
          value={inputMessage}
          onChange={(e) => setInputMessage(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !e.shiftKey && inputMessage.trim()) {
              e.preventDefault();
              handleSendMessage(inputMessage);
              setInputMessage('');
            }
          }}
          placeholder="Type a message..."
          className={styles.inputBox}
          rows={3}
        />

<div className={styles.iconGroupBottom}>
          <button
            className={styles.pillButton}
            onClick={toggleFeedbackModal}
            title="Send Feedback"
          >
            <FaBullhorn className={styles.pillIcon} />
            <span className={styles.pillText}>Feedback</span>
          </button>

          <button
            className={styles.roundButton}
            onClick={() => {
              if (inputMessage.trim()) {
                handleSendMessage(inputMessage);
                setInputMessage('');
              }
            }}
            title="Send Message"
          >
            <FaArrowUp />
          </button>
      </div>
    </div>

    {/* Always render the modal, but control visibility with isOpen */}
    <FeedbackModal isOpen={isFeedbackOpen} onClose={toggleFeedbackModal} />

</div>
  );
};

export default ChatInputBar;
